import { jsx as _jsx } from "react/jsx-runtime";
import { AlertTriangle } from 'lucide-react';
import { BaseState } from './BaseState';
export function ErrorState({ icon = AlertTriangle, title = 'Unable to load data', description, action, className = '' }) {
    return (_jsx(BaseState, { icon: icon, title: title, description: description, action: action, className: className, iconClassName: "text-orange-600 dark:text-orange-400", iconContainerClassName: "bg-orange-100 dark:bg-orange-900/20" }));
}
//# sourceMappingURL=ErrorState.js.map